var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "var(--icon-color)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2385 5113 c-635 -55 -1216 -400 -1568 -933 -226 -343 -353 -791 -334 -1185 32 -682 558 -1526 1573 -2525 215 -211 483 -461 503 -468 22 -8 660 626 973 968 668 727 1021 1336 1093 1886 68 518 -114 1104 -477 1531 -395 466 -997 740 -1607 731 -64 -1 -134 -3 -156 -5z m363 -324 c327 -36 622 -153 884 -351 447 -338 713 -898 684 -1443 -27 -516 -348 -1088 -1028 -1830 -178 -194 -710 -725 -726 -725 -16 0 -329 302 -511 493 -740 776 -1158 1437 -1236 1957 -55 357 53 790 280 1130 362 541 1006 840 1653 769z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460 3849 c-96 -12 -175 -36 -264 -80 -467 -232 -581 -844 -228 -1220 110 -117 225 -188 382 -235 52 -15 95 -19 215 -18 141 0 156 2 245 32 136 45 211 92 320 202 82 81 103 109 142 190 77 157 103 312 78 467 -48 304 -267 552 -560 636 -55 16 -207 38 -245 36 -11 -1 -49 -5 -85 -10z m225 -314 c171 -45 301 -177 339 -345 65 -285 -104 -543 -387 -591 -197 -33 -414 72 -499 242 -143 285 -3 613 295 694 70 18 179 18 252 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.981014e15f6836fec404f4ebacc2cd85.svg";
export { ForwardRef as ReactComponent };